import api from "@/services/api";
import type {
	ExpenseReportPeriod,
	ExpensesReportsSummaryResponse,
} from "../types";

export async function getExpensesReportsSummary(payload: ExpenseReportPeriod) {
	const { startDate, endDate, VehicleIds } = payload;

	const params = new URLSearchParams({
		startDate,
		endDate,
	});

	if (VehicleIds) {
		for (const id of VehicleIds) {
			params.append("VehicleIds", id);
		}
	}

	const { data } = await api.get<ExpensesReportsSummaryResponse>(
		"/api/expenses/reports/summary",
		{
			params,
		}
	);
	return data;
}
